import React from 'react';
import styles from '../style.module.scss';

interface I_Props {
    isWhole: boolean;
    setIsWhole: (isWhole: boolean) => void;
}

const ModeBtn: React.FC<I_Props> = ({ isWhole, setIsWhole }) => {
    return (
        <div className={styles.modeBtn}>
            <div
                onClick={() => {
                    setIsWhole(true);
                }}
                style={isWhole ? { color: '#669' } : { color: '#222' }}
            >
                完整行程
            </div>
            <div
                onClick={() => {
                    setIsWhole(false);
                }}
                style={isWhole ? { color: '#222' } : { color: '#669' }}
            >
                精簡行程
            </div>
        </div>
    );
};

export default ModeBtn;
